import React from 'react';
import { Box, useTheme } from '@mui/material';
import { scrollbarStyle } from '@theme/styles';
import { isDarkPagePalette } from '@theme/palettes/getPalette';

type DrawerContentProps = {
  drawerPadding?: string;
  drawerColor?: string;
  children?: React.ReactNode;
};

export const DrawerContent = (props: DrawerContentProps) => {
  const { drawerPadding = '16px', drawerColor = 'background.main', children } = props;
  const theme = useTheme();
  // dark page palettes (True Dark, holidays) have light text, so a white drawer makes the text unreadable
  const bgcolor = isDarkPagePalette(theme.palette) && drawerColor === 'common.white' ? 'background.main' : drawerColor;
  return (
    <Box
      padding={drawerPadding}
      bgcolor={bgcolor}
      sx={{
        padding: drawerPadding,
        bgcolor,
        display: 'flex',
        flexDirection: 'column',
        flexGrow: '1',
        overflowY: 'auto',
        overflowX: 'hidden',
        ...scrollbarStyle,
      }}
    >
      {children}
    </Box>
  );
};
